// extracted by mini-css-extract-plugin
export default {"refreshButton":"App_refreshButton__sCnTT"};